<template>
    <div :class="$attrs.class">
        <div class="row align-content-center">
            <div class="col-4 col-md-3 my-3 my-sm-0">
                <p class="text-md text-white m-0">
                    <img class="ms-2" src="/front/assets/images/sex.svg" alt="" title="">
                    جنسیت
                </p>
            </div>
            <div class="col-4 col-md-3 col-3 my-3 my-sm-0 sex ">
                <input
                    type="radio"
                    v-model="internalValue"
                    name="sex"
                    value="2"
                    id="female"
                />
                <label class="me-2 female" for="female">
                    <span class="female_icon"></span>
                    زن
                </label>
            </div>
            <div class="col-4 col-md-3 col-3 my-3 my-sm-0 sex">
                <input
                    type="radio"
                    v-model="internalValue"
                    name="sex"
                    value="1"
                    id="man"
                />
                <label class="me-2 man" for="man">
                    <span class="man_icon"></span>
                    مرد
                </label>
            </div>
            <div v-if="error" class="form-error"><p class="m-0 text-sm text-error mb-3">{{ error }}</p></div>
        </div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },
        error: String,
        modelValue: Number,
    },
    emits: ['update:modelValue'],
    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
}
</script>
